import { GET } from "../http"

export const GetResources = (LanguageId) => {
     if(LanguageId)
          return GET(`Shell/GetOptimaResourcesDictionary?uilanguageid=${LanguageId}`);
     else return GET("Shell/GetOptimaResourcesDictionary");
}

export const GetResourcesByList = (LanguageId, messages, texts) => {
    if (LanguageId)
        return GET(`Shell/GetResourcesByList?uilanguageid=${LanguageId}`, { messages, texts });
    else return GET("Shell/GetResourcesByList", { messages, texts });
}

